export const FETCH_RECENT_CREATED_SKILLS_SUCCESS = 'FETCH_RECENT_CREATED_SKILLS_SUCCESS';
export const FETCH_RECENT_CREATED_SKILLS_FAILURE = 'FETCH_RECENT_CREATED_SKILLS_FAILURE';
export const FETCH_POPULAR_SKILLS_SUCCESS = 'FETCH_POPULAR_SKILLS_SUCCESS';
export const FETCH_POPULAR_SKILLS_FAILURE = 'FETCH_POPULAR_SKILLS_FAILURE';
export const FETCH_USER_SKILLS_REPORT_SUCCESS = 'FETCH_USER_SKILLS_REPORT_SUCCESS';
export const FETCH_USER_SKILLS_REPORT_FAILURE = 'FETCH_USER_SKILLS_REPORT_FAILURE';
export const FETCH_USER_PENDING_SKILLS_SUCCESS = 'FETCH_USER_PENDING_SKILLS_SUCCESS';
export const FETCH_USER_PENDING_SKILLS_FAILURE = 'FETCH_USER_PENDING_SKILLS_FAILURE';
